/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">Select A Category</h4>
        <div>
            <!-- Default form login -->
            <form class="border border-light p-5">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label>Target</label>
                        <select class="form-control mb-4" ref="target">
                            <option value="RUNNER">RUNNER</option>
                            <option value="TODDLER">TODDLER</option>
                        </select>
                    </div>
                    <div class="form-group col-md-6">
                        <!-- Sign in button -->
                        <button v-if="page == 'add-homework'" class="btn btn-info btn-block my-4" @click.prevent="chooseCategory('add-homework')">Proceed To Choose Level</button>
                        <button v-if="page == 'edit-homework'" class="btn btn-info btn-block my-4" @click.prevent="chooseCategory('edit-homework')">Proceed To Choose Level</button>
                    </div>
                </div>

            </form>
            <!-- Default form login -->
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'SelectCategory',
    components: {

    },
    data() {
        return {
            page: this.$route.params.page,
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    methods: {
        chooseCategory(page) {

            let category = this.$refs.target.value
            if (page == 'add-homework') {
                this.$router.push({
                    name: 'Levels',
                    params: {
                        page: 'add-homework',
                        cat: category
                    }
                })
            }

            if (page == 'edit-homework') {
                this.$router.push({
                    name: 'Levels',
                    params: {
                        page: 'edit-homework',
                        cat: category
                    }
                })
            }
        }
    }
}
</script>
